<template>
    <div class="auth-container">
        <h2>Authenticating...</h2>
        <Toast class="custom-toast" />
    </div>
</template>

<script>
import { onMounted, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

export default {
    name: 'AuthCallback',
    setup() {
        const router = useRouter();
        const store = useStore();
        const { proxy } = getCurrentInstance();

        const failAndRedirect = (detail = 'SSO authentication failed.') => {
            proxy.$toast.add({
                severity: 'error',
                summary: 'Error',
                detail,
                life: 5000,
            });
            router.push({ name: 'login' });
        };

        onMounted(async () => {
            const urlParams = new URLSearchParams(window.location.search);
            const authCode = urlParams.get('code');
            const state = urlParams.get('state');
            const session_state = urlParams.get('session_state');

            if (!authCode || !state) {
                failAndRedirect('Authentication failed: Missing auth details.');
                return;
            }

            try {
                const result = await store.dispatch('auth/callbackSSO', {
                    authCode,
                    state,
                    session_state,
                });

                if (result?.success && store.getters['auth/isLoggedIn']) {
                    router.push('/');
                    return;
                }

                failAndRedirect();
            } catch (error) {
                failAndRedirect();
            }
        });
    },
};
</script>

<style scoped>
.auth-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    font-size: 1.5rem;
    font-weight: bold;
}
</style>
